import { TimelineLite, TweenLite, Power2, Expo } from 'gsap/TweenMax';

// import { qs } from '@/scripts/utils';

const canvasHover = (el, dmap, delay) => {
  const tl = new TimelineLite({
    paused: true,
  });

  const elAnimation = TweenLite.to(el, 0.75, {
    alpha: 1,
    y: 0,
    ease: Expo.easeOut,
  });

  TweenLite.set(el, { y: 35 });

  tl
    .add('start')
    .fromTo(dmap.scale, 0.4, {
      x: 200,
      y: 70,
    }, {
      y: 0,
      x: 0,
      ease: Power2.easeInOut,
    }, 0);
  tl
    .add(elAnimation, `start+=${delay}`);

  return tl;
};

export default canvasHover;



// WEBPACK FOOTER //
// ./src/scripts/timelines/canvas.js